"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App_Video = void 0;

App_Video = function () {
  function App_Video() {
    (0, _jquery2.default)(document).ready(function () {
      var page_url = void 0;
      var player = void 0;
      var player_url = void 0;
      var postToVideo = void 0;
      var startVideo = void 0;
      var url_params = void 0;
      player = (0, _jquery2.default)(".video-hold iframe");
      player_url = window.location.protocol + player.attr("src").split("?")[0];
      page_url = window.location.href;
      url_params = page_url.split("?")[1];
      postToVideo = function postToVideo(action, value) {
        var data = void 0;
        var message = void 0;
        data = {
          method: action
        };
        if (value) {
          data.value = value;
        }
        message = JSON.stringify(data);
        player[0].contentWindow.postMessage(data, player_url);
      };
      startVideo = function startVideo() {
        (0, _jquery2.default)("#reveal-video").removeClass("hidden").addClass("visible");
        postToVideo("play");
      };
      if (typeof url_params !== "undefined" && url_params.includes("play=true")) {
        startVideo();
      }
      (0, _jquery2.default)(".video-link").on("click", function (e) {
        e.preventDefault();
        return startVideo();
      });
      (0, _jquery2.default)(".modal-overlay").on("click", function (e) {
        postToVideo("pause");
      });
      (0, _jquery2.default)(document).bind("keydown", function (_ref) {
        var keyCode = _ref.keyCode;

        var esc = void 0;
        esc = 27;
        switch (keyCode) {
          case esc:
            postToVideo("pause");
        }
      });
    });
  }

  return App_Video;
}();

exports.default = App_Video;